import {
  ROUTE_EDIT_REQUEST,
  ROUTE_EDIT_SUCCESS,
  ROUTE_EDIT_FAILURE,
} from './types/EditRouteActionsTypes';

export function putRouteEditRequestActionCreator(
  context,
  selectedAssetRouteId,
  selectedDescription,
  selectedEndDate,
  selectedPriority,
  selectedStartDate,
  selectedRouteLeadingCounts,
  selectedTransferLocations,
  ) {
  return {
    type: ROUTE_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        assetRouteId: selectedAssetRouteId,
        description: selectedDescription,
        endDate: selectedEndDate,
        priority: selectedPriority,
        startDate: selectedStartDate,
        routeLeadingCounts: selectedRouteLeadingCounts,
        transferLocations: selectedTransferLocations,
      },
    },
  };
}

export function putRouteEditSuccessActionCreator(data) {
  return {
    type: ROUTE_EDIT_SUCCESS,
    payload: data,
  };
}

export function putRouteEditFailureActionCreator(error) {
  return {
    type: ROUTE_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
